import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import Routes from '../../lib/links/Routes';
import withCustomer from '../../containers/withCustomer';
import { CustomerRecord } from '../../entities/records';

function CustomerName({ customerId, customer, noLink }) {
  if (!customer) {
    return null;
  }

  if (noLink) {
    return <span>{customer.name}</span>;
  }

  if (!customerId) {
    return null;
  }

  return (
    <Link to={Routes.customers.view({ id: customerId })}>{customer.name}</Link>
  );
}

CustomerName.defaultProps = {
  customerId: undefined,
  customer: undefined,
  noLink: false,
};

CustomerName.propTypes = {
  customerId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  customer: PropTypes.instanceOf(CustomerRecord),
  noLink: PropTypes.bool,
};

export default withCustomer(CustomerName);
